import { useMemo } from 'react'
import type { TableLayoutMetrics } from 'src/domain/planTables/tableLayout'
import usePlanLabelPdfMetrics from './usePlanLabelPdfMetrics'

/**
 * Font size (pt) and pt → world factor the plan tables are laid out with, so their scene size
 * matches the exported plan. Same plan settings (and fallbacks) as the plan labels.
 */
const usePlanTableLayoutMetrics = (): TableLayoutMetrics => {
  const { fontSize, ptToWorld } = usePlanLabelPdfMetrics()
  return useMemo(() => ({ fontSize, ptToWorld }), [fontSize, ptToWorld])
}

export default usePlanTableLayoutMetrics
